import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

const r = SCOPES.printqueueRead;

/** The Print queue group's pages, in screen order (children of its node in `NAV`). */
export const PRINTQUEUE_NAV: NavNode[] = [
  {
    path: '/printqueue/jobs',
    label: 'Print jobs',
    requires: r,
    description: 'Queued, fetched, printed and failed jobs: re-queue, delete, download.',
  },
  {
    path: '/printqueue/printservers',
    label: 'Print servers',
    requires: r,
    description:
      'Print servers per tenant with their state (live, polling, last contact) and their printers.',
  },
  {
    path: '/printqueue/tokens',
    label: 'Tokens',
    requires: r,
    description: 'WorkServer and print server tokens: create and revoke.',
  },
  {
    path: '/printqueue/tenants',
    label: 'Tenants',
    requires: r,
    description: "Each tenant's move to AUTH tokens: allow, require, AUTH clients for print servers.",
  },
];
